import { isAppVersionAtLeast } from './url'

/**
 * Registry of webview features and their minimum version requirements
 */
export const WEBVIEW_FEATURES = {
  STATS_DRILL_EDIT: { minVersion: 235, name: 'Stats Drill Edit' },
  // add more features here ...
} as const

export type WebviewFeature = keyof typeof WEBVIEW_FEATURES

/**
 * Check if multiple features are available
 * @param features - Array of features to check
 * @returns Array of booleans in the same order as input features
 */
export const useWebviewFeatures = (features: WebviewFeature[]): boolean[] => {
  // Dynamically call hooks for all requested features
  return features.map((feature) => {
    const { minVersion } = WEBVIEW_FEATURES[feature]
    return isAppVersionAtLeast(minVersion)
  })
}
